/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Record_Toggle_TitleInputs */



/**
* | output |
* | --- |
* | "Record Enable/Disable" |
*
* @param {Player_Record_Toggle_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_record_toggle_title = /** @type {((inputs?: Player_Record_Toggle_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Record_Toggle_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer/Desactiver l'Enregistrement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufzeichnung aktivieren/deaktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita/Disabilita registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включение/отключение записи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar/deshabilitar grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用/禁用录制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("記録の有効化/無効化")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड सक्षम/अक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/Desativar gravação")
	return /** @type {LocalizedString} */ ("Record Enable/Disable")
});